import { useEffect, useState, useMemo } from 'react';
import { Box} from '@mui/material';
import '../../../pages/AssignPromotion/AssignPromotionPage.css';
import '../GridItems.css';
import { CurrencyTableItem } from '../../../types/componentTypes/CurrencyTypes';
import { CurrencySelector } from './components/CurrencySelector';
import { CurrencyValidity } from './components/CurrencyValidity';
import { CurrencyEntry } from './components/CurrencyEntry';
import { Leaderboard } from './components/Leaderboard';
import { useCountries } from '../../../hooks/useCountries';

interface CurrenciesProps {
    formik: any;
    isEdit?: boolean;
    mainBoxClass?: string;
    contentBoxClass?: string;
}

function CurrencyDetails({
    formik,
    isEdit = false,
    mainBoxClass,
    contentBoxClass,
}: CurrenciesProps) {
    const defaultSelectedCurrs = useMemo(() => {
        const currencyNames = formik.values.tempParams.currencyNames || [];
        return currencyNames.filter((curr: string) => curr);
    }, [formik.values.tempParams.currencyNames]);
    const [selectedCurrencies, setSelectedCurrencies] = useState(defaultSelectedCurrs);
    const [currencyAllocations, setCurrencyAllocations] = useState(defaultSelectedCurrs.length ? { ...defaultSelectedCurrs } : {} );

    const [filteredCurrencies, setFilteredCurrencies] = useState(['']);
    const [providedCurrencies, setProvidedCurrencies] = useState<
        CurrencyTableItem[]
    >([]);
    const [currencyList, setCurrencyList] = useState<string[]>([]);
    const [mechanic, setMechanic] = useState(formik.values.tempParams.flowOption);
    const { getCountryCodes } = useCountries();


    useEffect(() => {
        setMechanic(formik.values.tempParams.flowOption);
    }, [formik.values.tempParams.flowOption]);

    useEffect(() => {

        const countryValue = getCountryCodes(
            formik.values.configurationParameters?.country
        );

        const currencies = formik.values.tempParams.availableCurrencies.filter(
            (currency: { country: string }) =>
                currency.country === countryValue
        );
        const currenciesList = currencies.map((obj: any) => {
            return obj.name
        });

        if (isEdit) {
            const formikCurrenciesValues =
                formik.values?.configurationParameters?.currencies;
            if (formikCurrenciesValues) {
                const filteredCurrencies = currencies
                    .filter((currency: { currency_id: string }) =>
                        formikCurrenciesValues.includes(currency.currency_id)
                    )
                    .map(({ name }) => name);
                setFilteredCurrencies(filteredCurrencies);
            }
        }
        setCurrencyList(currenciesList);
        setProvidedCurrencies(currencies);
    }, [
        formik.values?.tempParams.availableCurrencies,
        formik.values?.configurationParameters.country,
        formik.values?.configurationParameters?.currencies,
        formik.values?.params?.reduceAmount,
        isEdit,
        getCountryCodes
    ]);
    return (
        <Box className={mainBoxClass || 'text-box-currencies'}>
            <CurrencySelector
                formik={formik}
                filteredCurrencies={filteredCurrencies}
                currencyList={currencyList}
                mechanic={mechanic}
                isEdit={isEdit}
                contentBoxClass={contentBoxClass}
                providedCurrencies={providedCurrencies}
                selectedCurrencies={selectedCurrencies}
                setCurrencyAllocations={setCurrencyAllocations}
                setSelectedCurrencies={setSelectedCurrencies}
            />
            {(mechanic === 'Collect & Get' || mechanic === 'Auto Collect & Get') ? (
                <CurrencyValidity
                    formik={formik}
                    isEdit={isEdit}
                    contentBoxClass={contentBoxClass}
                />
            ) : (
                <CurrencyEntry
                    formik={formik}
                    isEdit={isEdit}
                    mechanic={mechanic}
                    providedCurrencies={providedCurrencies}
                    currencyList={currencyList}
                    selectedCurrencies={selectedCurrencies}
                    currencyAllocations={currencyAllocations}
                    setCurrencyAllocations={setCurrencyAllocations}
                    setSelectedCurrencies={setSelectedCurrencies}
                />
            )}
           <Leaderboard formik={formik} isEdit={isEdit} configCurrencies={filteredCurrencies} providedCurrencies={providedCurrencies} contentBoxClass={contentBoxClass}/>
        </Box>
    );
}

export { CurrencyDetails };
